import { render, staticRenderFns } from "./VueAlert.vue?vue&type=template&id=65852396&scoped=true"
import script from "./VueAlert.vue?vue&type=script&lang=js"
export * from "./VueAlert.vue?vue&type=script&lang=js"
import style0 from "./VueAlert.vue?vue&type=style&index=0&id=65852396&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65852396",
  null
  
)

export default component.exports